import * as React from "react";
import { Gapped, Input, Select } from "react-ui";

import { Caption, Row } from "../../FiasFnsManualEditor.styles";
import { getHouseTypeLongName } from "../../../../FiasInput/Utils/Convertations/House/House";
import { getAddBuildingItems } from "../FiasFnsManualEditorUtils";

interface HousingProps {
    type: string | undefined;
    number: string | undefined;
    onTypeChange: (next: string) => void;
    onNumberChange: (next: string) => void;
}

export function Housing({ type, number, onTypeChange, onNumberChange }: HousingProps): JSX.Element | null {
    const add1BuildingItems = getAddBuildingItems(type);

    return (
        <Row>
            <Caption />
            <Gapped>
                <Select<string | undefined, string>
                    width={80}
                    value={getHouseTypeLongName(type) || type || undefined}
                    onValueChange={next => onTypeChange(next ?? "")}
                    placeholder={"Тип"}
                    data-tid={"HousingType"}
                    items={add1BuildingItems}
                />
                <Input
                    width={80}
                    maxLength={255}
                    value={number ?? ""}
                    placeholder={"Номер"}
                    data-tid={"HousingNum"}
                    onValueChange={next => onNumberChange(next ?? "")}
                />
            </Gapped>
        </Row>
    );
}
